import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SignatureBg } from "../components/SignatureBg";
import { staffAuth } from "../lib/api";

export default function ForgotPasswordPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await staffAuth.forgotPassword(email.trim().toLowerCase());
    } catch {
      // The endpoint never reveals whether an account exists — always confirm.
    } finally {
      setBusy(false);
      setSent(true);
    }
  }

  return (
    <div className="login-page has-signature-bg">
      <SignatureBg />
      <div className="login-card">
        <div className="brand-lockup login-brand">
          <div className="brand-mark" aria-hidden="true"><img src="/brand-logo.png" alt="" /></div>
          <div>
            <strong className="brand-wordmark">Alief Funding Hub</strong>
            <span>Funding Hub</span>
          </div>
        </div>
        {sent ? (
          <>
            <h1>Check your email</h1>
            <p className="muted" style={{ margin: "0 0 16px" }}>
              If an account exists for <strong>{email}</strong>, a password-reset link is on its way.
              The link expires in an hour.
            </p>
            <button className="ghost-button wide-button" onClick={() => nav("/login")}>Back to sign-in</button>
          </>
        ) : (
          <>
            <h1 id="forgot-heading">Reset your password</h1>
            <p className="muted" style={{ margin: "0 0 8px" }}>
              Enter your email and we'll send you a link to set a new password.
            </p>
            <form onSubmit={submit} className="stacked-form" aria-labelledby="forgot-heading">
              <label className="form-field">
                <span>Email</span>
                <input type="email" autoComplete="email" value={email}
                  onChange={(e) => setEmail(e.target.value)} required />
              </label>
              <button className="primary-button wide-button" disabled={busy}>
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <button className="link-button" style={{ marginTop: 12 }} onClick={() => nav("/login")}>
              Back to sign-in
            </button>
          </>
        )}
      </div>
    </div>
  );
}
